import React from 'react'
import classNames from 'classnames'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { microcopyTransform } from '@toasttab/shared/src/utils/contentfulUtils'
import { KeyTakeawaysCardText } from '@toasttab/shared/src/utils/Contentful/richText'
import { anchorLinkScroll } from '@toasttab/shared/src/utils/linkUtils'
import { KeyTakeawaysCardProps } from './KeyTakeaways.d'

const KeyTakeawaysCard = ({
  anchorLink,
  description,
  keyStat,
  keyStatColor,
  title
}: KeyTakeawaysCardProps) => {
  const { microCopyData } = usePageContext()

  const handleClick = (e: any) => {
    const target = e.currentTarget.getAttribute('data-href')
    if (target) {
      anchorLinkScroll(`#${target}`)
    }
  }

  const keyStatStyles = classNames(
    'rounded-xl px-2 flex items-center text-base',
    {
      'bg-sky-0 text-blue-75': keyStatColor === 'Blue',
      'bg-grass-0 text-increase before:content-icon-arrow-increase before:mr-1 before:relative before:mt-[-4px]':
        keyStatColor === 'Green',
      'bg-terracotta-0 text-decrease before:content-icon-arrow-decrease before:mr-1 before:relative before:mt-[-3px]':
        keyStatColor === 'Red'
    }
  )

  description.raw = microcopyTransform(microCopyData, description.raw)

  return (
    <button
      className='p-4 text-left rounded-md border border-color-light hover:shadow-floating'
      data-testid='KeyTakeawaysCard'
      data-href={anchorLink}
      onClick={handleClick}
    >
      <div className='flex flex-wrap justify-between pb-4 border-b border-color-light gap-1'>
        <h3 className='flex-shrink-0 font-semibold text-base max-w-full w-full md:w-auto'>
          {title}
        </h3>
        <span className={keyStatStyles}>{keyStat}</span>
      </div>
      <div className='pt-4'>
        {renderRichText(description, KeyTakeawaysCardText)}
      </div>
    </button>
  )
}

export default KeyTakeawaysCard
